{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} et {{ moreCount }} autres",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} et {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} fichier",
  "{{ count }} files_many": "{{ count }} fichiers",
  "{{ count }} files_other": "{{ count }} fichiers",
  "{{ count }} members_one": "{{ count }} membre",
  "{{ count }} members_many": "{{ count }} membres",
  "{{ count }} members_other": "{{ count }} membres",
  "{{ count }} members added_one": "{{ count }} membre ajouté",
  "{{ count }} members added_many": "{{ count }} membres ajoutés",
  "{{ count }} members added_other": "{{ count }} membres ajoutés",
  "{{ count }} people are typing_one": "{{ count }} personne écrit",
  "{{ count }} people are typing_many": "{{ count }} personnes écrivent",
  "{{ count }} people are typing_other": "{{ count }} personnes écrivent",
  "{{ count }} photos_one": "{{ count }} photo",
  "{{ count }} photos_many": "{{ count }} photos",
  "{{ count }} photos_other": "{{ count }} photos",
  "{{ count }} reactions_one": "{{ count }} réaction",
  "{{ count }} reactions_many": "{{ count }} réactions",
  "{{ count }} reactions_other": "{{ count }} réactions",
  "{{ count }} videos_one": "{{ count }} vidéo",
  "{{ count }} videos_many": "{{ count }} vidéos",
  "{{ count }} videos_other": "{{ count }} vidéos",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} et {{ secondUser }}",
  "{{ imageCount }} more": "{{ imageCount }} supplémentaires",
  "{{ member }} will be able to message you again.": "{{ member }} pourra à nouveau vous envoyer des messages.",
  "{{ member }} won't be able to message you anymore.": "{{ member }} ne pourra plus vous envoyer de messages.",
  "{{ memberCount }} members": "{{ memberCount }} membres",
  "{{ typing }} are typing": "{{ typing }} écrivent",
  "{{ typing }} is typing": "{{ typing }} écrit",
  "{{ user }} has been muted": "{{ user }} a été mis en sourdine",
  "{{ user }} has been unmuted": "{{ user }} n'est plus en sourdine",
  "{{ user }} is typing...": "{{ user }} est en train d'écrire...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} et {{ user }} sont en train d'écrire...",
  "{{ users }} and more are typing...": "{{ users }} et plus sont en train d'écrire...",
  "{{ watcherCount }} online": "{{ watcherCount }} en ligne",
  "{{count}} new messages_one": "{{count}} nouveau message",
  "{{count}} new messages_many": "{{count}} nouveaux messages",
  "{{count}} new messages_other": "{{count}} nouveaux messages",
  "{{count}} unread_one": "{{count}} non lu",
  "{{count}} unread_many": "{{count}} non lus",
  "{{count}} unread_other": "{{count}} non lus",
  "{{count}} votes_one": "{{count}} vote",
  "{{count}} votes_many": "{{count}} votes",
  "{{count}} votes_other": "{{count}} votes",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+{{count}} option de plus",
  "+{{count}} more options_many": "+{{count}} options de plus",
  "+{{count}} more options_other": "+{{count}} options de plus",
  "🏙 Attachment...": "🏙 Pièce jointe...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} a créé : {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} a voté : {{pollOptionText}}",
  "📍Shared location": "📍Emplacement partagé",
  "Actions": "Actions",
  "Add": "Ajouter",
  "Add {{ count }} members_one": "Ajouter {{ count }} membre",
  "Add {{ count }} members_many": "Ajouter {{ count }} membres",
  "Add {{ count }} members_other": "Ajouter {{ count }} membres",
  "Add a comment": "Ajouter un commentaire",
  "Add a comment to your poll answer": "Ajoutez un commentaire à votre réponse au sondage",
  "Add an option": "Ajouter une option",
  "Add channel members": "Ajouter des membres au canal",
  "Add members": "Ajouter des membres",
  "Add reaction": "Ajouter une réaction",
  "Admin": "Admin",
  "All results loaded": "Tous les résultats sont chargés",
  "Allow access to camera": "Autoriser l'accès à la caméra",
  "Allow access to microphone": "Autoriser l'accès au microphone",
  "Allow comments": "Autoriser les commentaires",
  "Allow option suggestion": "Autoriser la suggestion d'options",
  "Allow others to add comments": "Permettre à d'autres d'ajouter des commentaires",
  "Already a member": "Déjà membre",
  "Also send as a direct message": "Également envoyer en message direct",
  "Also send in channel": "Également envoyer dans le canal",
  "Also sent in channel": "Également envoyé dans le canal",
  "An error has occurred during recording": "Une erreur s'est produite pendant l'enregistrement",
  "An error has occurred during the recording processing": "Une erreur s'est produite pendant le traitement de l'enregistrement",
  "Anonymous": "Anonyme",
  "Anonymous poll": "Sondage anonyme",
  "Archive": "Archiver",
  "Are you sure you want to delete this message?": "Êtes-vous sûr de vouloir supprimer ce message ?",
  "Are you sure you want to leave this channel?": "Are you sure you want to leave this channel?",
  "aria/Attachment": "Pièce jointe",
  "aria/Attachment Actions": "Actions de la pièce jointe",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "Position audio {{ elapsed }} sur {{ duration }}",
  "aria/Audio position {{ progress }} percent": "Position audio {{ progress }} pour cent",
  "aria/Block User": "Bloquer l'utilisateur",
  "aria/Bookmark Message": "Enregistrer le message",
  "aria/Cancel recording": "Annuler l'enregistrement",
  "aria/Cancel Reply": "Annuler la réponse",
  "aria/Cancel upload": "Annuler le téléchargement",
  "aria/Channel Actions": "Actions du canal",
  "aria/Channel details": "Détails du canal",
  "aria/Channel list": "Liste des canaux",
  "aria/Channel search results": "Résultats de recherche de canaux",
  "aria/Chat view tabs": "Onglets de la vue de chat",
  "aria/Clear search": "Effacer la recherche",
  "aria/Close callout dialog": "Fermer la boîte de dialogue d'information",
  "aria/Close thread": "Fermer le fil",
  "aria/Collapse sidebar": "Réduire la barre latérale",
  "aria/Command Suggestions": "Suggestions de commandes",
  "aria/Complete recording": "Terminer l'enregistrement",
  "aria/Copy Message Text": "Copier le texte du message",
  "aria/Decrease value": "Diminuer la valeur",
  "aria/Delete Message": "Supprimer le message",
  "aria/Dismiss notification": "Ignorer la notification",
  "aria/Download attachment": "Télécharger la pièce jointe",
  "aria/Edit Message": "Éditer un message",
  "aria/Emoji picker": "Sélecteur d'émojis",
  "aria/Emoji Suggestions": "Suggestions d'émojis",
  "aria/Exit search": "Quitter la recherche",
  "aria/Expand sidebar": "Développer la barre latérale",
  "aria/File input": "Entrée de fichier",
  "aria/File upload": "Téléchargement de fichier",
  "aria/Flag Message": "Signaler le message",
  "aria/Image failed to load": "Échec du chargement de l'image",
  "aria/Image input": "Entrée d'image",
  "aria/Increase value": "Augmenter la valeur",
  "aria/Jump to latest message": "Aller au dernier message",
  "aria/Jump to quoted message": "Aller au message cité",
  "aria/Load More Channels": "Charger plus de canaux",
  "aria/Mark Message Unread": "Marquer comme non lu",
  "aria/Mark messages as read": "Marquer les messages comme lus",
  "aria/Mention Suggestions": "Suggestions de mentions",
  "aria/Menu": "Menu",
  "aria/Message Actions": "Actions du message",
  "aria/Message from {{ user }},": "Message de {{ user }},",
  "aria/Message Options": "Options du message",
  "aria/Message,": "Message,",
  "aria/Mute User": "Mettre en sourdine",
  "aria/Next page": "Page suivante",
  "aria/Notifications": "Notifications",
  "aria/Open Attachment Selector": "Ouvrir le sélecteur de pièces jointes",
  "aria/Open Channel Actions Menu": "Ouvrir le menu des actions du canal",
  "aria/Open channel details": "Ouvrir les détails du canal",
  "aria/Open image shared by {{ name }}": "Ouvrir l'image partagée par {{ name }}",
  "aria/Open Menu": "Ouvrir le menu",
  "aria/Open Message Actions Menu": "Ouvrir le menu des actions du message",
  "aria/Open Reaction Selector": "Ouvrir le sélecteur de réactions",
  "aria/Open Thread": "Ouvrir le fil",
  "aria/Open video shared by {{ name }}": "Ouvrir la vidéo partagée par {{ name }}",
  "aria/Pause": "Pause",
  "aria/Pause recording": "Mettre en pause l'enregistrement",
  "aria/Percent complete": "{{percent}} pour cent terminé",
  "aria/Pin Message": "Épingler le message",
  "aria/Play": "Lecture",
  "aria/Previous page": "Page précédente",
  "aria/Quote Message": "Citer le message",
  "aria/Reaction list": "Liste des réactions",
  "aria/Remind Me Message": "Me rappeler",
  "aria/Remind Me Options": "Options de rappel",
  "aria/Remove attachment": "Supprimer la pièce jointe",
  "aria/Remove location attachment": "Supprimer la pièce jointe d'emplacement",
  "aria/Remove option": "Supprimer l'option",
  "aria/Remove Reminder": "Supprimer le rappel",
  "aria/Remove Save For Later": "Supprimer « Enregistrer pour plus tard »",
  "aria/Resend Message": "Renvoyer le message",
  "aria/Resume recording": "Reprendre l'enregistrement",
  "aria/Retry upload": "Réessayer le téléchargement",
  "aria/Review bounced message": "Examiner le message rejeté",
  "aria/Search results": "Résultats de recherche",
  "aria/Search results header filter button for: {{ source }}": "Bouton de filtre d'en-tête des résultats de recherche pour : {{ source }}",
  "aria/Seek audio position": "Rechercher la position audio",
  "aria/Select Channel: {{ channelName }}": "Sélectionner le canal : {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "Sélectionner la réaction : {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "Sélectionner le canal utilisateur : {{ name }}",
  "aria/Send": "Envoyer",
  "aria/Show preview": "Afficher l'aperçu",
  "aria/Start recording audio": "Commencer l'enregistrement audio",
  "aria/Stop AI Generation": "Arrêter la génération d'IA",
  "aria/Suggestions": "Suggestions",
  "aria/Thread list": "Liste des fils",
  "aria/Unblock User": "Débloquer l'utilisateur",
  "aria/Unmute User": "Désactiver muet",
  "aria/Unpin Message": "Détacher le message",
  "Ask a question": "Poser une question",
  "Attach": "Joindre",
  "Attach files": "Joindre des fichiers",
  "Attachment": "Pièce jointe",
  "Attachment upload blocked due to {{reason}}": "Téléchargement de pièce jointe bloqué en raison de {{reason}}",
  "Attachment upload failed due to {{reason}}": "Échec du téléchargement de la pièce jointe en raison de {{reason}}",
  "Back": "Retour",
  "ban-command-args": "[@nomdutilisateur] [texte]",
  "ban-command-description": "Bannir un utilisateur",
  "Block user": "Bloquer l'utilisateur",
  "Block User": "Bloquer l'utilisateur",
  "Browse channel members": "Parcourir les membres du canal",
  "Browse pinned messages": "Parcourir les messages épinglés",
  "Cancel": "Annuler",
  "Cannot seek in the recording": "Impossible de rechercher dans l'enregistrement",
  "Changes saved": "Modifications enregistrées",
  "Channel archived": "Canal archivé",
  "Channel members": "Membres du canal",
  "Channel Missing": "Canal Manquant",
  "Channel muted": "Canal mis en sourdine",
  "Channel pinned": "Canal épinglé",
  "Channel unarchived": "Canal désarchivé",
  "Channel unmuted": "Sourdine du canal désactivée",
  "Channel unpinned": "Canal désépinglé",
  "Channels": "Canaux",
  "Chat deleted": "Chat deleted",
  "Chats": "Discussions",
  "Choose between 2 to 10 options": "Choisir entre 2 et 10 options",
  "Close": "Fermer",
  "Close dialog": "Fermer la boîte de dialogue",
  "Close emoji picker": "Fermer le sélecteur d'émojis",
  "Close prompt: {{ title }}": "Fermer l'invite : {{ title }}",
  "Command not available while editing": "Commande non disponible pendant la modification",
  "Command not available while replying": "Commande non disponible pendant la réponse",
  "Commands": "Commandes",
  "Commands matching": "Correspondance des commandes",
  "Connection failure, reconnecting now...": "Échec de la connexion, reconnexion en cours...",
  "Contact info": "Informations du contact",
  "Contact name": "Nom du contact",
  "Copy Message": "Copier le message",
  "Create": "Créer",
  "Create a question, add options, and configure poll settings": "Créez une question, ajoutez des options et configurez les paramètres du sondage",
  "Create poll": "Créer un sondage",
  "Current location": "Emplacement actuel",
  "Delete": "Supprimer",
  "Delete chat": "Supprimer le chat",
  "Delete for me": "Supprimer pour moi",
  "Delete message": "Supprimer le message",
  "Delivered": "Publié",
  "Direct message": "Message direct",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "Voulez-vous terminer ce sondage maintenant ? Personne ne pourra plus voter dans ce sondage.",
  "Download All": "Tout télécharger",
  "Download Attachment": "Télécharger la pièce jointe",
  "Download attachment {{ name }}": "Télécharger la pièce jointe {{ name }}",
  "Drag your files here": "Glissez vos fichiers ici",
  "Drag your files here to add to your post": "Glissez vos fichiers ici pour les ajouter à votre publication",
  "Due {{ timeLeft }}": "Échéance dans {{ timeLeft }}",
  "Due since {{ dueSince }}": "Échéance depuis {{ dueSince }}",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit": "Modifier",
  "Edit chat data": "Modifier les données du chat",
  "Edit contact": "Modifier le contact",
  "Edit group": "Modifier le groupe",
  "Edit Message": "Éditer un message",
  "Edit message request failed": "Échec de la demande de modification du message",
  "Edited": "Modifié",
  "Emoji matching": "Correspondance d'émojis",
  "Empty message...": "Message vide...",
  "End": "Fin",
  "End poll": "Terminer le sondage",
  "End this poll?": "Terminer ce sondage ?",
  "End vote": "Fin du vote",
  "Enforce unique vote is enabled": "Le vote unique est activé",
  "Error": "Erreur",
  "Error adding flag": "Erreur lors de l'ajout du signalement",
  "Error adding members": "Error adding members",
  "Error blocking user": "Erreur lors du blocage de l'utilisateur",
  "Error connecting to chat, refresh the page to try again.": "Erreur de connexion au chat, rafraîchissez la page pour réessayer.",
  "Error deleting chat": "Error deleting chat",
  "Error deleting message": "Erreur lors de la suppression du message",
  "Error fetching reactions": "Erreur lors du chargement des réactions",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "Erreur lors de la marque du message comme non lu. Impossible de marquer des messages non lus plus anciens que les 100 derniers messages du canal.",
  "Error muting a user ...": "Erreur lors de la mise en sourdine d'un utilisateur...",
  "Error muting channel": "Erreur lors de la mise en sourdine du canal",
  "Error muting user": "Erreur lors de la mise en sourdine de l'utilisateur",
  "Error opening direct message": "Erreur lors de l'ouverture du message direct",
  "Error pinning message": "Erreur lors de l'épinglage du message",
  "Error removing members": "Erreur lors du retrait des membres",
  "Error removing message pin": "Erreur lors du retrait de l'épinglage du message",
  "Error removing user": "Erreur lors du retrait de l'utilisateur",
  "Error reproducing the recording": "Erreur lors de la reproduction de l'enregistrement",
  "Error starting recording": "Erreur lors du démarrage de l'enregistrement",
  "Error unblocking user": "Erreur lors du déblocage de l'utilisateur",
  "Error unmuting a user ...": "Erreur lors du démarrage de la sourdine d'un utilisateur ...",
  "Error unmuting channel": "Erreur lors de la désactivation de la sourdine du canal",
  "Error unmuting user": "Erreur lors de la désactivation de la sourdine de l'utilisateur",
  "Error uploading attachment": "Erreur lors du téléchargement de la pièce jointe",
  "Error uploading file": "Erreur lors du téléchargement du fichier",
  "Error uploading image": "Erreur lors de l'envoi de l'image",
  "Error: {{ errorMessage }}": "Erreur : {{ errorMessage }}",
  "Exit command {{ command }}": "Quitter la commande {{ command }}",
  "Failed to block user": "Impossible de bloquer l'utilisateur",
  "Failed to create the poll": "Échec de la création du sondage",
  "Failed to create the poll due to {{reason}}": "Échec de la création du sondage en raison de {{reason}}",
  "Failed to delete the message": "Échec de la suppression du message",
  "Failed to end the poll": "Impossible de terminer le sondage",
  "Failed to end the poll due to {{reason}}": "Impossible de terminer le sondage en raison de {{reason}}",
  "Failed to jump to the first unread message": "Échec du saut vers le premier message non lu",
  "Failed to leave channel": "Impossible de quitter le canal",
  "Failed to load channels": "Impossible de charger les canaux",
  "Failed to load more channels": "Impossible de charger davantage de canaux",
  "Failed to mark channel as read": "Échec du marquage du canal comme lu",
  "Failed to play the recording": "Impossible de lire l'enregistrement",
  "Failed to retrieve location": "Impossible de récupérer l'emplacement",
  "Failed to save changes": "Échec de l'enregistrement des modifications",
  "Failed to share location": "Impossible de partager l'emplacement",
  "Failed to update channel archive status": "Impossible de mettre à jour l'état d'archivage du canal",
  "Failed to update channel mute status": "Impossible de mettre à jour l'état de la mise en sourdine du canal",
  "Failed to update channel pinned status": "Impossible de mettre à jour l'état d'épinglage du canal",
  "File": "Fichier",
  "File is required for upload attachment": "Un fichier est requis pour joindre une pièce",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "Le fichier est trop volumineux : {{ size }}, la taille maximale de téléchargement est de {{ limit }}",
  "File too large": "Fichier trop volumineux",
  "fileCount_one": "1 fichier",
  "fileCount_many": "{{ count }} fichiers",
  "fileCount_other": "{{ count }} fichiers",
  "Files": "Fichiers",
  "Flag": "Signaler",
  "Generating...": "Génération...",
  "giphy-command-args": "[texte]",
  "giphy-command-description": "Poster un GIF aléatoire dans le canal",
  "Go back": "Retour",
  "Group info": "Informations du groupe",
  "Group name": "Nom du groupe",
  "Hide who voted": "Masquer qui a voté",
  "Image": "Image",
  "imageCount_one": "Photo",
  "imageCount_many": "{{ count }} photos",
  "imageCount_other": "{{ count }} photos",
  "Instant commands": "Commandes instantanées",
  "language/af": "Afrikaans",
  "language/am": "Amharique",
  "language/ar": "Arabe",
  "language/az": "Azéri",
  "language/bg": "Bulgare",
  "language/bn": "Bengali",
  "language/bs": "Bosnien",
  "language/cs": "Tchèque",
  "language/da": "Danois",
  "language/de": "Allemand",
  "language/el": "Grec",
  "language/en": "Anglais",
  "language/es": "Espagnol",
  "language/es-MX": "Espagnol (Mexique)",
  "language/et": "Estonien",
  "language/fa": "Persan",
  "language/fa-AF": "Dari",
  "language/fi": "Finnois",
  "language/fr": "Français",
  "language/fr-CA": "Français (Canada)",
  "language/ha": "Haoussa",
  "language/he": "Hébreu",
  "language/hi": "Hindi",
  "language/hr": "Croate",
  "language/ht": "Créole haïtien",
  "language/hu": "Hongrois",
  "language/id": "Indonésien",
  "language/it": "Italien",
  "language/ja": "Japonais",
  "language/ka": "Géorgien",
  "language/ko": "Coréen",
  "language/lt": "Lituanien",
  "language/lv": "Letton",
  "language/ms": "Malais",
  "language/nl": "Néerlandais",
  "language/no": "Norvégien",
  "language/pl": "Polonais",
  "language/ps": "Pachto",
  "language/pt": "Portugais",
  "language/ro": "Roumain",
  "language/ru": "Russe",
  "language/sk": "Slovaque",
  "language/sl": "Slovène",
  "language/so": "Somali",
  "language/sq": "Albanais",
  "language/sr": "Serbe",
  "language/sv": "Suédois",
  "language/sw": "Swahili",
  "language/ta": "Tamoul",
  "language/th": "Thaï",
  "language/tl": "Tagalog",
  "language/tr": "Turc",
  "language/uk": "Ukrainien",
  "language/ur": "Ourdou",
  "language/vi": "Vietnamien",
  "language/zh": "Chinois (simplifié)",
  "language/zh-TW": "Chinois (traditionnel)",
  "Last seen {{ timestamp }}": "Vu pour la dernière fois {{ timestamp }}",
  "Leave Channel": "Quitter le canal",
  "Leave chat": "Quitter le canal",
  "Left channel": "Canal quitté",
  "Let others add options": "Permettre à d'autres d'ajouter des options",
  "Limit votes per person": "Limiter les votes par personne",
  "Link": "Lien",
  "linkCount_one": "Lien",
  "linkCount_many": "{{ count }} liens",
  "linkCount_other": "{{ count }} liens",
  "live": "en direct",
  "Live for {{duration}}": "En direct pendant {{duration}}",
  "Live location": "Emplacement en direct",
  "Live until {{ timestamp }}": "En direct jusqu'à {{ timestamp }}",
  "Load more": "Charger plus",
  "Local upload attachment missing local id": "Pièce jointe locale sans identifiant local",
  "Location": "Emplacement",
  "Location sharing ended": "Partage d'emplacement terminé",
  "Location: {{ coordinates }}": "Emplacement : {{ coordinates }}",
  "Manage channel": "Gérer le canal",
  "Manage members": "Gérer les membres",
  "Mark as unread": "Marquer comme non lu",
  "Maximum number of votes (from 2 to 10)": "Nombre maximum de votes (de 2 à 10)",
  "Maximum votes per person": "Nombre maximal de votes par personne",
  "Member detail": "Détails du membre",
  "mention/Channel": "Canal",
  "mention/Channel Description": "Notifier tout le monde dans ce canal",
  "mention/Here": "Ici",
  "mention/Here Description": "Notifier tous les membres en ligne dans ce canal",
  "Menu": "Menu",
  "Message deleted": "Message supprimé",
  "Message failed to send": "Échec de l'envoi du message",
  "Message has been successfully flagged": "Le message a été signalé avec succès",
  "Message marked as unread": "Message marqué comme non lu",
  "Message pinned": "Message épinglé",
  "Message unpinned": "Message désépinglé",
  "Message was blocked by moderation policies": "Le message a été bloqué par les politiques de modération",
  "Messages have been marked unread.": "Les messages ont été marqués comme non lus.",
  "Missing permissions to upload the attachment": "Autorisations manquantes pour télécharger la pièce jointe",
  "Moderator": "Modérateur",
  "Multiple votes": "Votes multiples",
  "Mute": "Muet",
  "Mute chat": "Mettre le chat en sourdine",
  "Mute user": "Mettre l'utilisateur en sourdine",
  "mute-command-args": "[@nomdutilisateur]",
  "mute-command-description": "Muter un utilisateur",
  "network error": "erreur réseau",
  "New": "Nouveau",
  "New message from {{user}}": "Nouveau message de {{user}}",
  "New Messages!": "Nouveaux Messages!",
  "Next": "Suivant",
  "Next image": "Image suivante",
  "No chats here yet…": "Pas encore de messages ici...",
  "No conversations yet": "Aucune conversation pour le moment",
  "No files": "Aucun fichier",
  "No items exist": "Aucun élément",
  "No member found": "Aucun membre trouvé",
  "No messages found": "Aucun message trouvé",
  "No photos or videos": "Aucune photo ni vidéo",
  "No pinned messages": "Aucun message épinglé",
  "No results found": "Aucun résultat trouvé",
  "No user found": "Aucun utilisateur trouvé",
  "Nobody will be able to vote in this poll anymore.": "Personne ne pourra plus voter dans ce sondage.",
  "Nothing yet...": "Rien pour l'instant...",
  "Notify all {{ role }} members": "Notifier tous les membres ayant le rôle {{ role }}",
  "Offline": "Hors ligne",
  "Ok": "D'accord",
  "Online": "En ligne",
  "Only numbers are allowed": "Seuls les chiffres sont autorisés",
  "Only visible to you": "Visible uniquement pour vous",
  "Open emoji picker": "Ouvrir le sélecteur d'émojis",
  "Open gallery at image {{ index }}": "Ouvrir la galerie à l'image {{ index }}",
  "Open image in gallery": "Ouvrir l'image dans la galerie",
  "Open location in a map": "Ouvrir l'emplacement dans une carte",
  "Open members actions": "Open members actions",
  "Open menu": "Ouvrir le menu",
  "Option already exists": "L'option existe déjà",
  "Option is empty": "L'option est vide",
  "Options": "Options",
  "Original": "Original",
  "Owner": "Propriétaire",
  "People matching": "Correspondance de personnes",
  "Photo": "Photo",
  "Photos & videos": "Photos et vidéos",
  "Pin": "Épingler",
  "Pin a message to see it here": "Épinglez un message pour le voir ici",
  "Pinned by {{ name }}": "Épinglé par {{ name }}",
  "Pinned by You": "Épinglé par vous",
  "Pinned message": "Message épinglé",
  "Pinned messages": "Messages épinglés",
  "placeholder/PollComment": "Votre commentaire",
  "placeholder/PollOptionSuggestion": "Saisir une nouvelle option",
  "Play video": "Lire la vidéo",
  "Playback speed {{ rate }}x": "Vitesse de lecture {{ rate }}x",
  "Poll": "Sondage",
  "Poll comments": "Commentaires du sondage",
  "Poll ended": "Sondage terminé",
  "Poll options": "Options du sondage",
  "Poll results": "Résultats du sondage",
  "Previous": "Précédent",
  "Previous image": "Image précédente",
  "Question": "Question",
  "Question {{ optionOrderNumber}}": "Question {{ optionOrderNumber}}",
  "Question is required": "La question est obligatoire",
  "Quote Reply": "Répondre par citation",
  "Reached the vote limit. Remove an existing vote first.": "La limite de votes a été atteinte. Supprimez d'abord un vote existant.",
  "Recording format is not supported and cannot be reproduced": "Le format d'enregistrement n'est pas pris en charge et ne peut pas être reproduit",
  "Remind me": "Me rappeler",
  "Remind Me": "Me rappeler",
  "Reminder set": "Rappel défini",
  "Remove": "Retirer",
  "Remove {{ count }} members_one": "Retirer {{ count }} membre",
  "Remove {{ count }} members_many": "Retirer {{ count }} membres",
  "Remove {{ count }} members_other": "Retirer {{ count }} membres",
  "Remove {{ member }} from this channel?": "Retirer {{ member }} de ce canal ?",
  "Remove channel members": "Retirer les membres du canal",
  "Remove reminder": "Supprimer le rappel",
  "Remove save for later": "Supprimer « Enregistrer pour plus tard »",
  "Remove user": "Retirer l'utilisateur",
  "Removed {{ count }} members_one": "{{ count }} membre retiré",
  "Removed {{ count }} members_many": "{{ count }} membres retirés",
  "Removed {{ count }} members_other": "{{ count }} membres retirés",
  "Replied to a thread": "A répondu à un fil",
  "Reply": "Répondre",
  "Reply to {{ authorName }}": "Répondre à {{ authorName }}",
  "Reply to a message to start a thread": "Répondez à un message pour démarrer un fil",
  "Reply to Message": "Répondre au message",
  "replyCount_one": "1 réponse",
  "replyCount_many": "{{ count }} réponses",
  "replyCount_other": "{{ count }} réponses",
  "Resend": "Renvoyer",
  "Retry upload": "Réessayer le téléchargement",
  "Review all options available in this poll": "Consultez toutes les options disponibles dans ce sondage",
  "Review comments submitted with poll answers": "Consultez les commentaires envoyés avec les réponses au sondage",
  "Review poll results and open an option to see detailed votes": "Consultez les résultats du sondage et ouvrez une option pour voir les votes détaillés",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "Consultez ce message et choisissez de le supprimer, le modifier ou l'envoyer quand même",
  "Review who voted for this option": "Consultez qui a voté pour cette option",
  "Save": "Enregistrer",
  "Save for later": "Enregistrer pour plus tard",
  "Saved for later": "Enregistré pour plus tard",
  "Search": "Rechercher",
  "Search GIFs": "Rechercher des GIFs",
  "search-results-header-filter-source-button-label--channels": "canaux",
  "search-results-header-filter-source-button-label--messages": "messages",
  "search-results-header-filter-source-button-label--users": "utilisateurs",
  "Searching for {{ searchSourceType }}...": "Recherche de {{ searchSourceType }}...",
  "Searching...": "Recherche en cours...",
  "searchResultsCount_one": "1 résultat",
  "searchResultsCount_many": "{{ count }} résultats",
  "searchResultsCount_other": "{{ count }} résultats",
  "Select a thread to continue the conversation": "Sélectionnez un fil pour continuer la conversation",
  "Select more than one option": "Sélectionner plus d'une option",
  "Select one": "Sélectionner un",
  "Select one or more": "Sélectionner un ou plusieurs",
  "Select up to {{count}}_one": "Sélectionner jusqu'à {{count}}",
  "Select up to {{count}}_many": "Sélectionner jusqu'à {{count}}",
  "Select up to {{count}}_other": "Sélectionner jusqu'à {{count}}",
  "Select your current location and optionally enable live location sharing": "Sélectionnez votre position actuelle et activez éventuellement le partage de position en direct",
  "Send": "Envoyer",
  "Send a message": "Envoyez un message",
  "Send a message to start the conversation": "Envoyez un message pour commencer la conversation",
  "Send Anyway": "Envoyer quand même",
  "Send direct message": "Envoyer un message direct",
  "Send message request failed": "Échec de la demande d'envoi de message",
  "Send poll": "Envoyer le sondage",
  "Sending...": "Envoi en cours...",
  "Sent": "Envoyé",
  "Share": "Partager",
  "Share a file to see it here": "Partagez un fichier pour le voir ici",
  "Share a photo or video to see it here": "Partagez une photo ou une vidéo pour la voir ici",
  "Share live location for": "Partager l'emplacement en direct pendant",
  "Share Location": "Partager l'emplacement",
  "Shared live location": "Emplacement en direct partagé",
  "Shared location": "Position partagée",
  "Shuffle": "Mélanger",
  "size limit": "limite de taille",
  "Slow Mode ON": "Mode lent activé",
  "Slow mode, wait {{ seconds }}s...": "Mode lent, attendez {{ seconds }} s...",
  "Some of the files will not be accepted": "Certains fichiers ne seront pas acceptés",
  "Start typing to search": "Commencez à taper pour rechercher",
  "Stop sharing": "Arrêter de partager",
  "Submit": "Envoyer",
  "Suggest a new option to add to this poll": "Suggérez une nouvelle option à ajouter à ce sondage",
  "Suggest an option": "Suggérer une option",
  "Tap to remove": "Appuyez pour retirer",
  "Tap to remove: {{ reactionName }}": "Appuyez pour retirer: {{ reactionName }}",
  "Thinking...": "Réflexion...",
  "this content could not be displayed": "ce contenu n'a pas pu être affiché",
  "This field cannot be empty or contain only spaces": "Ce champ ne peut pas être vide ou contenir uniquement des espaces",
  "This message did not meet our content guidelines": "Ce message ne respecte pas nos directives de contenu",
  "This permanently deletes your message history with {{ user }}. This can't be undone.": "This permanently deletes your message history with {{ user }}. This can't be undone.",
  "This user will be able to message you again.": "Cet utilisateur pourra à nouveau vous envoyer des messages.",
  "This user won't be able to message you anymore. You can unblock them anytime.": "This user won't be able to message you anymore. You can unblock them anytime.",
  "Thread": "Fil de discussion",
  "Thread has not been found": "Le fil de discussion n'a pas été trouvé",
  "Thread reply": "Réponse dans le fil",
  "Thread Reply": "Réponse dans le fil",
  "ThreadListUnseenThreadsBanner/loading": "Chargement...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} fil non lu",
  "ThreadListUnseenThreadsBanner/unreadThreads_many": "{{ count }} fils non lus",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} fils non lus",
  "Threads": "Fils",
  "timestamp/ChannelDetailPinnedMessageTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Yesterday]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/ChannelMembersLastActive": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Hier]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Aujourd'hui]\", \"nextDay\": \"[Demain]\", \"lastDay\": \"[Hier]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[Dernier] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "il y a {{ count }} j",
  "timestamp/relativeToday": "Aujourd'hui",
  "timestamp/relativeWeeksAgo": "il y a {{ count }} sem",
  "timestamp/relativeYesterday": "Hier",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Aujourd'hui] [à] HH:mm\", \"nextDay\": \"[Demain] [à] HH:mm\", \"lastDay\": \"[Hier] [à] HH:mm\", \"nextWeek\": \"dddd [à] HH:mm\", \"lastWeek\": \"dddd [dernier à] HH:mm\", \"sameElse\": \"ddd, D MMM [à] HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "Pour commencer l'enregistrement, autorisez l'accès à la caméra dans votre navigateur",
  "To start recording, allow the microphone access in your browser": "Pour commencer l'enregistrement, autorisez l'accès au microphone dans votre navigateur",
  "totalVoteCount_one": "1 vote au total",
  "totalVoteCount_many": "{{ count }} votes au total",
  "totalVoteCount_other": "{{ count }} votes au total",
  "Translated": "Traduit",
  "Translated from {{ language }}": "Traduit du {{ language }}",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "Tapez un nombre de 2 à 10",
  "Unarchive": "Désarchiver",
  "unban-command-args": "[@nomdutilisateur]",
  "unban-command-description": "Débannir un utilisateur",
  "Unblock": "Débloquer",
  "Unblock user": "Débloquer l'utilisateur",
  "Unblock User": "Débloquer l'utilisateur",
  "unknown error": "erreur inconnue",
  "Unmute": "Désactiver muet",
  "Unmute chat": "Désactiver la sourdine du chat",
  "Unmute user": "Désactiver la sourdine de l'utilisateur",
  "unmute-command-args": "[@nomdutilisateur]",
  "unmute-command-description": "Démuter un utilisateur",
  "Unpin": "Détacher",
  "Unread messages": "Messages non lus",
  "Unsupported attachment": "Pièce jointe non prise en charge",
  "unsupported file type": "type de fichier non pris en charge",
  "Update": "Mettre à jour",
  "Update the comment attached to your poll answer": "Mettez à jour le commentaire joint à votre réponse au sondage",
  "Update your comment": "Mettre à jour votre commentaire",
  "Upload blocked": "Téléversement bloqué",
  "Upload error": "Erreur de téléversement",
  "Upload failed": "Échec du téléversement",
  "Upload Picture": "Importer une image",
  "Upload type: \"{{ type }}\" is not allowed": "Le type de fichier : \"{{ type }}\" n'est pas autorisé",
  "User blocked": "Utilisateur bloqué",
  "User muted": "Utilisateur mis en sourdine",
  "User removed": "Utilisateur retiré",
  "User unblocked": "Utilisateur débloqué",
  "User unmuted": "Sourdine de l'utilisateur désactivée",
  "User uploaded content": "Contenu téléchargé par l'utilisateur",
  "Video": "Vidéo",
  "videoCount_one": "Vidéo",
  "videoCount_many": "{{ count }} vidéos",
  "videoCount_other": "{{ count }} vidéos",
  "View": "Voir",
  "View {{count}} comments_one": "Voir {{count}} commentaire",
  "View {{count}} comments_many": "Voir {{count}} commentaires",
  "View {{count}} comments_other": "Voir {{count}} commentaires",
  "View all": "Tout voir",
  "View member details for {{ member }}": "Voir les détails du membre {{ member }}",
  "View original": "Voir l'original",
  "View results": "Voir les résultats",
  "View translation": "Voir la traduction",
  "Voice message": "Message vocal",
  "Voice message {{ duration }}": "Message vocal {{ duration }}",
  "Voice message deleted": "Message vocal supprimé",
  "voiceMessageCount_one": "Mémo vocal",
  "voiceMessageCount_many": "{{ count }} mémos vocaux",
  "voiceMessageCount_other": "{{ count }} mémos vocaux",
  "Vote ended": "Vote terminé",
  "Votes": "Votes",
  "Wait until all attachments have uploaded": "Attendez que toutes les pièces jointes soient téléchargées",
  "Waiting for network…": "En attente du réseau…",
  "You": "Vous",
  "You've reached the maximum number of files": "Vous avez atteint le nombre maximal de fichiers"
}
